module.exports = __webpack_public_path__ + "static/custom-marker-f7f0b2510980ae4d5a8d71e2ea2f76c9.jpg";